var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"card",attrs:{"no-body":true}},[_c('div',{staticClass:"card-section"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }